import { useModuleGate, useModuleGateForWorkspace } from '../lib/moduleGate';

/**
 * True when typed conditions are on: decisions and plan commitments can carry
 * assumptions, thresholds, dependencies and external signals, and the
 * condition-health readouts render. Canonical gate (§2.7): the `conditions`
 * workspace module + flag.
 *
 * Spec: docs/9-exploration/CONDITION-MONITORING-AND-DECISION-EXPIRY-PRD.md.
 */
export function useConditionsEnabled(): boolean {
  return useModuleGate('conditions');
}

/**
 * The same gate resolved against the workspace a RECORD belongs to, for
 * surfaces reached by URL — a Plan of Record, a plan narrative, a decision map
 * — which can belong to a different workspace than the session's current one.
 * Using the session-scoped gate there silently falls back to hidden (the
 * 2026-08-21 defect note in src/lib/moduleGate.ts).
 */
export function useConditionsEnabledForWorkspace(
  workspaceId: string | null | undefined,
): boolean {
  return useModuleGateForWorkspace(workspaceId, 'conditions');
}
